import React from "react";
import l from "components/util/l";
import Toolbox from "components/studio/toolbox/Toolbox";
import NodeFormCreate from "components/studio/board/node_form/NodeFormCreate";
import SchemaForm from "components/util/schema_form/SchemaForm";
import Studio from "components/studio/Studio";


const ActionFormView = ({
  toolboxRef,
  studioRef,
  flow,
  pageId,
  nodes,
  toolboxId,
  defAppId,
  activeActionId,
  rootParams,
  nodeParams,
  activeSection,
  wizardFlow,
  isValidator,
  isCollapsed,
  isWizardMode,
  setActiveSection,
  onClickNode,
  onClickOpenToolbox,
  onClickCloseToolbox,
  onChangeMode,
  reloadFlow,
  createNode
}) => (
  <div className="card p-0 h-100 w-100">

    <div className="card-body p-0 h-100 w-100">
      <div className="d-flex h-100 w-100">
        <Toolbox
          toolboxRef={toolboxRef}
          studioRef={studioRef}
          flow={flow}
          pageId={pageId}
          toolboxId={toolboxId}
          defAppId={defAppId}
          activeSection={activeSection}
          activeActionId={activeActionId}
          nodes={nodes.filter((item) => item.type == "node")}
          nodeParams={nodeParams}
          showTabs={false}
          defaultWizardMode={nodeParams?.parentId ? false : true}
          wizardFlow={wizardFlow}
          isAnonymous={false}
          isCollapsed={isCollapsed}
          isValidator={isValidator}
          isWizardAssistant={true}
          setActiveSection={setActiveSection}
          onClickNode={onClickNode}
          onClickOpenToolbox={onClickOpenToolbox}
          onClickCloseToolbox={onClickCloseToolbox}
          onChangeMode={onChangeMode}
          reloadFlow={reloadFlow}
        />

        <div className="p-4 w-100 overflow-auto">
          {activeActionId ? (
            <NodeFormCreate
              match={{
                params: {
                  actionId: activeActionId
                }
              }}
              flowId={flow.id}
              activePageId={pageId}
              rootParams={rootParams}
              nodeParams={nodeParams}
              onSubmit={createNode}
            />
          ) : <>
            {
              isWizardMode 
                ? <>
                  <div className="d-flex h-100 w-100">
                    {
                      wizardFlow?.flow?.id &&
                        <Studio 
                          ref={studioRef}
                          match={{ params: { flowId: wizardFlow?.flow?.id } }}
                          isValidator={true}
                        />
                    }
                  </div>
                </>
                : <div className="card">
                  <div className="card-body text-center" style={{ paddingTop: "15.2rem", paddingBottom: "15.2rem" }}>
                    <i className="fas fa-shapes mb-4" style={{ fontSize: "3em", color: "#8090a0" }}></i>
                    <h4 style={{ fontSize: "1.2em", color: "#90a0aa", marginBottom: "0.25rem" }}>
                      {function () {
                        return nodeParams?.parentId
                          ? l("Continuar proceso%SA252")
                          : l("Nuevo proceso%SA253");
                      }()}
                    </h4>
                    <label style={{ fontSize: "0.85rem", width: "11rem", color: "#90a0aa" }}>
                      {
                        function () {
                          return nodeParams?.parentId
                            ? l("Sigue la guía del asesor para continuar tu proceso%SA255")
                            : l("Sigue la guía del asesor para iniciar tu proceso%SA254");
                        }()
                      }
                    </label>
                    {/* TODO: Temp hack to prevent reload */}
                    <div className="d-none"> <SchemaForm flowId={flow.id} /></div>
                  </div>
                </div>
            }
          </>
          }
        </div>

      </div>
    </div>

  </div>
);

export default ActionFormView;